module.exports = __webpack_public_path__ + "static/media/44_tn.f3425371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/44_tn.jpg
// module id = 257
// module chunks = 0